import { BillExportRepository } from "../../domain/repositories/BillExportRepository";
import {
  BillExportEntity,
  BillExportParamsEntity,
} from "../../domain/entities/BillExportEntity";
import { fetchBillExportExcel } from "../api/billExportsApi";

export class BillExportRepositoryImpl implements BillExportRepository {
  async downloadBillExportExcel(
    params: BillExportParamsEntity = {},
  ): Promise<BillExportEntity> {
    const dto = await fetchBillExportExcel({
      from_date: params.fromDate,
      to_date: params.toDate,
    });

    return {
      blob: dto.blob,
      filename: dto.filename,
    };
  }
}

